import React from 'react';
import { Field, reduxForm } from 'redux-form';

import { renderTextField } from '../../helpers/renderFormInputs';

const SnapshotForm = props => {
  const { handleSnapshotSaved, submitting, cancelSnapshot } = props;

  return (
    <form
      onSubmit={event => {
        handleSnapshotSaved(event);
      }}
      className="snapshot-note-form"
    >
      <Field
        multiLine
        rows={6}
        rowsMax={6}
        className="text-field-textarea"
        name="snapshotNote"
        fullWidth
        component={renderTextField}
      />

      <div className="buttons">
        <button
          type="button"
          className="btn--form btn--cancel-snapshot-form"
          onClick={() => cancelSnapshot()}
        >
          Cancel
        </button>

        <button type="submit" disabled={submitting} className="btn--form btn--submit-snapshot-form">
          Save
        </button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'snapshotForm',
})(SnapshotForm);
